import EyeDropper from "./EyeDropper";
import { convertColor } from "../../../_utils/common";
import React, { useState } from "react";
import { StyledEyeDropperIconContainer } from "../../styled/details/stylesTextPanel";
import { FaEyeDropper } from "react-icons/all";

const EyeDropperContainer = ({
  canvas,
  iconContainerStyle,
  onChange,
  iconColor = "#fff",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return canvas ? (
    <>
      <StyledEyeDropperIconContainer
        style={iconContainerStyle}
        className="eye-dropper-icon"
        onClick={() => {
          canvas.upperCanvasEl.style.setProperty("pointer-events", "none");
          setIsVisible(true);
        }}
      >
        <FaEyeDropper fill={iconColor} />
      </StyledEyeDropperIconContainer>
      {isVisible && (
        <EyeDropper
          context={canvas.lowerCanvasEl}
          onChange={(hex) => {
            setIsVisible(false);
            canvas.upperCanvasEl.style.setProperty("pointer-events", "unset");
            onChange && onChange({ hex, rgb: convertColor(hex, "rgb-object") });
          }}
        />
      )}
    </>
  ) : null;
};

export default EyeDropperContainer;
